import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useCart } from '../../../contexts/CartContext';
import ROUTES from '../../common/Routing/Routes';
import { getShopItems, Merchandise } from '../../common/Rest/Services/ShopService';
import { formatShopPrice, getShopImageUrl, toShopCartItem } from '../ShopPage/shopUtils';

const MAX_SUGGESTIONS = 3;

// Shop items cached for the session so reopening the cart doesn't refetch them.
let cachedShopItems: Merchandise[] | null = null;

function CartUpsell() {
  const { addToCart, isInCart, closeCartModal } = useCart();
  const [shopItems, setShopItems] = useState<Merchandise[]>(cachedShopItems ?? []);

  useEffect(() => {
    if (cachedShopItems) return;
    getShopItems('', 0, 20, true)
      .then((page) => {
        cachedShopItems = page.items;
        setShopItems(page.items);
      })
      .catch(() => setShopItems([]));
  }, []);

  const suggestions = shopItems
    .filter((item) => item.stockCount > 0 && !isInCart(item.id))
    .slice(0, MAX_SUGGESTIONS);

  if (!suggestions.length) return null;

  return (
    <section className="cart-upsell" aria-label="Додати до оренди">
      <Typography variant="subtitle2">Додати до оренди щось із крамнички?</Typography>
      <div className="cart-upsell-list">
        {suggestions.map((item) => (
          <div key={item.id} className="cart-upsell-item">
            <Link to={`${ROUTES.SHOP}/${item.id}`} onClick={closeCartModal} className="cart-upsell-link">
              <img src={getShopImageUrl(item, 'thumb')} alt={item.name} loading="lazy" />
              <span>
                <strong>{item.name}</strong>
                <span>{formatShopPrice(item.price)}</span>
              </span>
            </Link>
            <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => addToCart(toShopCartItem(item))}>
              Додати
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CartUpsell;
